<template lang="pug">
  .easyparcel
    v-container(style="max-width:600px")
      v-layout.ma-2.mb-12
        div
          v-icon.mt-1(left color="black" :size="20" @click="backToPrev") mdi-arrow-left
        .h6.primary500--text.mt-1| Easyparcel Setup
      v-layout.mt-3
        v-row.fill-height.ma-0( align='center' justify='center')
          div.mx-auto
            v-img.mx-auto(:src="require('@/assets/images/logo_easyparcel.png')" style="width:120px" contain)
            div.mt-2.caption(v-if="!settings.couriers") Get your free account
              a.ml-1(href="https://easyparcel.com/" target="_blank") here
      
      v-layout.my-6(v-if="isFetching")
        v-row.fill-height.ma-0(align='center' justify='center')
          v-progress-circular.ma-auto(:width="2" :size="50" color="primary" indeterminate)

      v-card.mt-6(v-else flat).justify--center
        v-card-title.justify--center(v-show='step < totalForms')
          v-layout.text--center
            div.mx-auto
              h6.s1.text-center.default--text {{ currentTitle }}
            // v-spacer
            // v-progress-circular.my-auto(:value="currentProgress" size='24' color="primary")
        v-window.pb-4.px-4(v-model='step')
          v-window-item(:value='1')
            v-form(ref="step1")
              .api-key
                p.mb-3.label.basic600--text.text-uppercase.mt-2 API Key
                v-text-field(solo flat background-color="basic200"    height="40" v-model='settings.api_key' outlined dense persistent-hint
                                  :label="$t('api_key.label')"
                                  :placeholder="$t('api_key.placeholder')"
                                  :rules="rules.not_empty")
              .phone
                p.mb-3.label.basic600--text.text-uppercase Phone number
                v-text-field(solo flat background-color="basic200"    height="40" v-model='settings.phone' outlined dense persistent-hint
                             :label="$t('phone.label')"
                             :placeholder="$t('phone.placeholder')"
                             :rules="rules.phone" type="tel"
                             @keypress="isNumber($event)")
          v-window-item(:value='2')
            v-form.mt-2(ref="step2")
              h6.label.basic600--text.text-uppercase I would like to:
              .postcode.mt-n4
                v-radio-group(v-model='settings.pickup' mandatory)
                  v-radio(:value="true")
                    template(v-slot:label)
                      v-col
                        div.s1.basic800--text Courier Pick Up
                        div.c1.basic600--text Courier rider will pick up the shipment from you.
                  v-radio(:value="false" hide-details dense)
                    template(v-slot:label)
                      v-col
                        div.s1.basic800--text Self Drop Off
                        div.c1.basic600--text Skip waiting time by dropping off your shipment at any nearest available branch

              .postcode
                p.mb-3.label.basic600--text.text-uppercase Shipment's postcode
                v-text-field(solo flat background-color="basic200"    height="40" v-model='form.shipmentPostcode' outlined dense persistent-hint type="number"
                             :label="$t('shipment_postcode.label')"
                             :placeholder="$t('shipment_postcode.placeholder')"
                             :rules="rules.not_empty")
          v-window-item(:value='3')
            v-form.mt-2(ref="step3")
              p.mb-3.label.basic600--text.text-uppercase Address Line 1
              v-text-field.mt-4(solo flat background-color="basic200"    height="40" v-model="address.address_1" :label="$t('address_1.label')" :placeholder="$t('address_1.placeholder')" outlined dense :rules="rules.not_empty")
              p.mb-3.label.basic600--text.text-uppercase Address Line 2
              v-combobox(solo flat background-color="basic200"    height="40" v-model="address.address_2" :label="$t('address_2.label')" :placeholder="$t('address_2.placeholder')" outlined dense :rules="rules.not_empty" :items="addresses2")
              p.mb-3.label.basic600--text.text-uppercase postcode
              v-text-field.p1(solo flat background-color="basic200"    height="40" v-model="address.postcode" :label="$t('postcode.label')" :placeholder="$t('postcode.placeholder')" outlined dense :rules="rules.not_empty" readonly)
                v-icon(color="green lighten-1" slot="append") mdi-check-circle
              p.mb-3.label.basic600--text.text-uppercase city
              v-text-field.p1(solo flat background-color="basic200"    height="40" v-model="address.city" :label="$t('city.label')" :placeholder="$t('city.placeholder')" outlined dense :rules="rules.not_empty" readonly)
                v-icon(color="green lighten-1" slot="append") mdi-check-circle
              p.mb-3.label.basic600--text.text-uppercase state
              v-text-field.p1(solo flat background-color="basic200"    height="40" v-model="address.state" :label="$t('state.label')" :placeholder="$t('state.placeholder')" outlined dense :rules="rules.not_empty" readonly)
                v-icon(color="green lighten-1" slot="append") mdi-check-circle
              p.mb-3.label.basic600--text.text-uppercase country
              v-text-field.p1(solo flat background-color="basic200"    height="40" v-model="address.country" :label="$t('country.label')" :placeholder="$t('country.placeholder')" outlined dense :rules="rules.not_empty" readonly)
                v-icon(color="green lighten-1" slot="append") mdi-check-circle
          
          v-window-item(:value='4')
            v-layout.my-6(v-if="searchingCouriers")
              v-row.fill-height.ma-0(align='center' justify='center')
                v-progress-circular.ma-auto(:width="2" :size="50" color="primary" indeterminate)
            v-form(v-else ref="step4")
              .contain-layout
                v-expansion-panels.mb-4(multiple tile flat outlined)
                  v-expansion-panel(v-for='(courier, index) in form.couriers' :key="courier.name")
                    v-divider(v-if="index != 0")
                    v-expansion-panel-header.pa-0(disable-icon-rotate)
                      template(v-slot:default='{ open }')
                        v-list-item
                          v-list-item-icon
                            v-card(flat)
                              v-img(:src="courier.courier_logo ? courier.courier_logo : require('@/assets/image_placeholder.png')" width=48, height=48)
                          v-list-item-content
                            v-col
                              span.s1 {{ courier.name }}
                              v-layout
                                div.c1.basic600--text Show nearest branch
                                v-icon.ml-1(size=16) mdi-chevron-down
                      template(v-slot:actions)
                        v-list-item-action(@click.stop="")
                          y-checkbox.ma-auto.mb-1(v-model="courier.selected" hide-details)
                    v-expansion-panel-content
                      v-divider.my-4
                      template(v-for="point in courier.points")
                        v-chip.ma-1.font-weight-light(small outlined color="primary" text-color="grey darken-1") {{ point.point_name }}

          v-window-item(:value='5')
            v-form(ref="step5")
              template(v-for="courier in form.selectedPointcouriers")
                p.mb-3.label.basic600--text.text-uppercase.mt-2 {{courier.name}}
                v-select.p1(solo flat background-color="basic200"    height="40" v-model='courier.point' return-object outlined dense
                         :label="courier.name"
                         :items="courier.points"
                         :rules="rules.has_quantity"
                         :key="courier.name")
                  template(v-slot:selection="data")
                    div.caption {{ data.item.point_name }}
                  template(v-slot:item="data")
                    div.caption {{ data.item.point_name }}
          v-window-item(:value='totalForms')
            v-row.fill-height.ma-0(align='center' justify='center')
              div.mx-auto
                div.mt-2.s1.default--text.text-center You're all set!
                p.p2.default--text.text-center You can now fulfill your shipments with easyparcel

        
        v-card-actions
          v-btn.button-AA-small(v-show='step > 1 && step < 5 '  text height=32 @click='goBack()')
            | Back
          v-spacer
          v-btn.button-AA-medium.mr-2.white--text(color='info500' block v-if='step === totalForms'  height=32 depressed @click="goHome()")
            | Finish
          v-btn.button-AA-medium.mr-2.white--text(color='info500' v-else  height=32 depressed @click='clickNextButton()' :loading="isLoading")
            | Next

</template>

<script>
import { mapActions } from 'vuex'
export default {
  name: 'SetupEasyparcel',
  props: ['company'],
  data (v) {
    return {
      step: 1,
      isFetching: false,
      totalForms: 6,
      settings : {
        id: null,
        api_key: '',
        phone: null,
        pickup: true,
        pickup_address: {
          address_1: '',
          address_2: '',
          postcode: '',
          city: '',
          state: '',
          country: ''
        },
        couriers: null,
        company: v.company.id,
      },
      form: {
        shipmentPostcode: null,
        selectedAddress: null,
        postcodeAddresses: [],
        couriers: [],
        selectedcourier: [],
        selectedPointcouriers: []
      },
      address: {
        address_1: '',
        address_2: '',
        postcode: '',
        city: '',
        state: '',
        country: ''
      },
      addresses2: [],
      searchingCouriers: true,
      isLoading: false,
      rules: {
        not_empty: [val => (val || '').length > 0 || 'This field is required'],
        has_quantity: [(v) => !!v || 'Item is required', (v) => v != 0|| 'Item is required'],
        phone: [
          v => !!v || 'Phone Number is required',
          v => /^[0-46-9]-*[0-9]{7,12}$/.test(v) || 'Phone Number must be valid',
        ],
      }
    }
  },
  computed: {
    currentTitle () {
      switch (this.step) {
        case 1: return 'Step 1: Account informations'
        case 2: return 'Step 2: Set shipment preference'
        case 3: return 'Step 3: Fill in full address'
        case 4: return 'Step 4: Select your prefered courier'
        case 5: return 'Step 5: Select your prefered branch'
        default: return 'Setup completed'
      }
    },
    currentProgress () {
      return Math.floor((this.step.toFixed(2) / this.totalForms.toFixed(2)) * 100)
    }
  },
  mounted () {
    this.fetchSettings()
  },
  methods: {
    ...mapActions([
      'showMessage'
    ]),
    backToPrev(){
      this.$emit('back', null)
    },
    isNumber: function(evt) {
      evt = (evt) ? evt : window.event;
      var charCode = (evt.which) ? evt.which : evt.keyCode;
      if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    fetchSettings () {
      this.$axios.get(`/shipping/settings/${this.company.slug}/easyparcel`).then((response) => {
          this.settings = response.data
          if (this.settings.pickup_address) {
            this.form.shipmentPostcode = this.settings.pickup_address.postcode
            if (this.settings.pickup_address.address_1) {
              this.address.address_1 = this.settings.pickup_address.address_1
            }
            if (this.settings.pickup_address.address_2) {
              this.address.address_2 = this.settings.pickup_address.address_2
            }
          }
      })
      .catch(() => {})
      .finally(
        this.isFetching = false
      )
    },
    goHome () {
      location.href = '/admin/settings/easyparcel'
    },
    goBack () {
      this.step--
    },
    clickNextButton () {
      if (this.step === 1) {
        if (!this.$refs.step1.validate()) {
          return
        }
        this.step++
        return
      } else if (this.step === 2) {
        if (!this.$refs.step2.validate()) {
          return
        }
        if (this.form.shipmentPostcode == this.settings.pickup_address.postcode) {
          this.address = this.settings.pickup_address
          this.step++
          return
        }
        this.isLoading = true
        this.$axios.get(`/shipping/postcodes?postcode=${this.form.shipmentPostcode}`).then((response) => {
          const addresses = response.data
          if (addresses.length > 0 && addresses[0].postcode) {
            this.address.postcode = addresses[0].postcode
            this.address.city = addresses[0].city
            this.address.state = addresses[0].state
            this.address.country = addresses[0].country
            addresses.forEach(address => {
              this.addresses2.push(address.address_2)
            })
            this.step++
          } else {
            this.showMessage(['error', this.$t('error_message.invalid_postcode_number')])
          }
        })
        .catch(() => {
          this.showMessage(['error', this.$t('error_message.invalid_postcode_number')])
        })
        .finally(() => {
          this.isLoading = false
        })
        return
      } else if (this.step === 3) {
        if (!this.$refs.step3.validate()) {
          return
        }
        this.settings.pickup_address = this.address
        this.searchingCouriers = true
        this.step++
      } else if (this.step === 4) {
        this.form.selectedPointcouriers = []
        this.form.couriers.forEach(item => {
          if (item.selected) {
            this.form.selectedPointcouriers.push(item)
          }
        })
        if (this.form.selectedPointcouriers.length == 0) {
          this.showMessage(['error', this.$t('error_message.please_select_courier')])
          return
        }
        this.step++
        return
      } else if (this.step === 5) {
        if (!this.$refs.step5.validate()) {
          return
        }
        this.settings.couriers = []
        this.form.selectedPointcouriers.forEach(courier => {
          const newCourier = {
            name: courier.name,
            enable: true,
            point_name: courier.point.point_name,
            point_id: courier.point.point_id,
            require_min_order: courier.require_min_order,
            service: courier.service,
            courier_logo: courier.courier_logo,
            courier_id: courier.courier_id
          }
          this.settings.couriers.push(newCourier)
        })
        this.settings.pickup_address = this.address
        this.searchingCouriers = true
        this.step++
      }
      //if (this.settings.id) {
        //this.axios.put(`/shipping/easyparcel_settings/${this.settings.id}/`, this.settings)
        this.axios.put(`/shipping/settings/${this.company.slug}/easyparcel`, this.settings)
        .then(resp => {
          this.settings = resp.data
          if (this.step == 4) {
            this.form.couriers = []
            this.form.selectedcourier = []
            this.searchCouriers()
          }
        })
        .catch(() => {
          this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
          this.step--
        })
        return
      //}

      //TODO: iru?
      //this.axios.post(`/shipping/easyparcel_settings/`, this.settings)
      
      /*
      this.axios.post(`/shipping/settings/${this.company.slug}/easyparcel`, this.settings)
        .then(resp => {
          this.settings = resp.data
          if (this.step == 4) {
            this.form.couriers = []
            this.form.selectedcourier = []
            this.searchCouriers()
          }
        })
        .catch(() => {
          this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
          this.step--
        })
      */
    },
    searchCouriers () {
      //this.$axios.get(`/shipping/easyparcel_settings/${this.settings.id}/couriers`)
      this.$axios.get(`/shipping/settings/${this.company.slug}/easyparcel/couriers`)
        .then((response) => {
          const couriers = response.data.couriers
          couriers.forEach((item, index) => {
            let selected = false
            let selectedCouriers = []
            if (this.settings.couriers) {
              selectedCouriers = this.settings.couriers.filter((obj) => {
                return obj.name == item.name
              })
            }
            if (selectedCouriers.length > 0) {
              selected = true
            }
            couriers[index].points = response.data.points[item.name]
            couriers[index].selected = selected
            let selectedPoint = null
            if (selectedCouriers.length > 0) {
              const selectedPoints = couriers[index].points.filter((obj) => {
                return obj.point_id == selectedCouriers[0].point_id
              })
              if (selectedPoints.length > 0) {
                selectedPoint = selectedPoints[0]
              }
            }
            couriers[index].point = selectedPoint
            if (couriers[index].points.length > 0) {
              this.form.couriers.push(couriers[index])
            }
          })
        })
        .catch((e) => {
          if (e.response && e.response.data && e.response.data.message) {
            this.showMessage(['error', e.response.data.message])
          } else {
            this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
          }
          this.step--
        })
        .finally(() => {
          this.searchingCouriers = false
        })
    }
  }
}
</script>

<i18n>
{
  "en": {
    "api_key": {
      "label": "API key",
      "placeholder": "Write your API key here"
    },
    "phone": {
      "label": "Phone No",
      "placeholder": "Write your phone number here"
    },
    "shipment_postcode": {
      "label": "Shipment's Postcode",
      "placeholder": "Write your shipment location's postcode here"
    },
    "shipment_address": {
      "label": "Shipment's Address",
      "placeholder": "Select your shipment location here "
    },
    "address_1": {
      "label": "Address Line 1",
      "placeholder": "e.g. K-3-01, Conezion, Persiaran IRC3"
    },
    "address_2": {
      "label": "Address Line 2",
      "placeholder": "e.g. IOI Resort City"
    },
    "postcode": {
      "label": "Postcode",
      "placeholder": "e.g. 62502"
    },
    "city": {
      "label": "City",
      "placeholder": "e.g. Putrajaya"
    },
    "state": {
      "label": "State",
      "placeholder": "e.g. Wilayah Persekutuan Putrajaya"
    },
    "country": {
      "label": "Country",
      "placeholder": "e.g. Malaysia"
    }
  },
  "ms": {
    "test": "Assalamualaikum"
  }
}
</i18n>

<style scoped>
.v-text-field--outlined >>> fieldset {
  border-color: var(--v-primary200);
}

.v-card--outlined >>> fieldset {
  border-color: var(--v-primary200);
}
</style>